<div class="max-card-dialog-info h-100">
  <div class="p-3 h-100" *ngIf="!loading">
    <div class="flex align-items-center justify-content-between">
      <div>
        <span class="font-light">
          Imagens do pedido
          <i class="primary pi pi-fw pi-images"></i>
        </span>
      </div>
      <button mat-dialog-close mat-icon-button color="warn">
        <i class="p-button-danger pi pi-times-circle"></i>
      </button>
    </div>
    <p-carousel
      [value]="imagens"
      [numVisible]="1"
      [numScroll]="imagens.length"
      [circular]="true"
      [responsiveOptions]="responsiveOptions"
      autoplayInterval="2500"
    >
      <ng-template let-imagem pTemplate="item">
        <div
          class="m-2 text-center py-5 px-3"
        >
          <div class="mb-3">
            <img
              [src]="imagem.imagem_arquivo"
              alt="imagem"
              class="w-10 shadow-1"
            />
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </div>
  <div class="app-loading" *ngIf="loading">
    <h4 class="text-splash">
      Carregando imagens, por-favor aguarde!
    </h4>
    <div class="content-spinner">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  </div>
</div>
